import React, { useState } from "react";
import { cn } from "../../lib/cn";

/** Toggle visually like antd Switch; supports uncontrolled mode */
export function Switch({
  checked: checkedProp,
  defaultChecked,
  onChange,
  checkedChildren,
  unCheckedChildren,
  className,
  disabled,
  style,
}) {
  const isControlled = checkedProp !== undefined;
  const [inner, setInner] = useState(!!defaultChecked);
  const checked = isControlled ? !!checkedProp : inner;

  return (
    <button
      type="button"
      disabled={disabled}
      style={style}
      role="switch"
      aria-checked={checked}
      onClick={() => {
        if (disabled) return;
        const next = !checked;
        if (!isControlled) setInner(next);
        onChange?.(next);
      }}
      className={cn(
        "relative inline-flex h-9 min-w-[56px] items-center rounded-full border px-1.5 text-xs font-bold uppercase tracking-wide transition",
        checked
          ? "border-brand bg-brand text-white"
          : "border-slate-300 bg-slate-100 text-slate-700",
        disabled && "opacity-50",
        className
      )}
    >
      <span className="px-2">
        {checked ? checkedChildren ?? "On" : unCheckedChildren ?? "Off"}
      </span>
    </button>
  );
}
